/**
 * Natureland Theme JavaScript
 */

(function () {
  'use strict';

  // DOM Elements
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  const mobileMenuPanel = document.getElementById('mobile-menu-panel');

  // Cart Drawer Functions
  function openCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawer.classList.remove('invisible');
      cartDrawer.classList.remove('translate-x-full');
      cartDrawerOverlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (cartDrawer && cartDrawerOverlay) {
      cartDrawer.classList.add('translate-x-full');
      cartDrawerOverlay.classList.add('hidden');
      document.body.style.overflow = '';
      // Hide after transition completes to prevent flashing on page navigation
      setTimeout(() => {
        if (cartDrawer.classList.contains('translate-x-full')) {
          cartDrawer.classList.add('invisible');
        }
      }, 300);
    }
  }

  // Mobile Menu Functions
  function openMobileMenu() {
    if (mobileMenuOverlay && mobileMenuPanel) {
      mobileMenuOverlay.classList.remove('hidden');
      setTimeout(() => {
        mobileMenuPanel.classList.remove('-translate-x-full');
        mobileMenuPanel.classList.add('translate-x-0');
      }, 10);
      document.body.style.overflow = 'hidden';

      // Toggle header button icons and color
      const menuToggle = document.getElementById('mobile-menu-toggle');
      if (menuToggle) {
        const menuIcon = menuToggle.querySelector('.menu-icon');
        const closeIcon = menuToggle.querySelector('.close-icon');
        if (menuIcon) menuIcon.classList.add('hidden');
        if (closeIcon) closeIcon.classList.remove('hidden');
        // Force dark color when menu is open (visible on white background)
        menuToggle.classList.remove('text-white');
        menuToggle.classList.add('text-deep-charcoal');
      }

      // Force logo to dark color when menu is open
      const header = document.getElementById('site-header');
      if (header) {
        const logoLink = header.querySelector('.logo-link');
        if (logoLink) {
          logoLink.classList.remove('text-white');
          logoLink.classList.add('text-deep-charcoal');
        }
      }
    }
  }

  function closeMobileMenu() {
    if (mobileMenuOverlay && mobileMenuPanel) {
      mobileMenuPanel.classList.remove('translate-x-0');
      mobileMenuPanel.classList.add('-translate-x-full');
      setTimeout(() => {
        mobileMenuOverlay.classList.add('hidden');
      }, 500);
      document.body.style.overflow = '';

      // Toggle header button icons and restore color
      const menuToggle = document.getElementById('mobile-menu-toggle');
      const header = document.getElementById('site-header');
      const isTransparent = header && header.dataset.transparent === 'true';
      const scrolled = window.scrollY > 50;

      if (menuToggle) {
        const menuIcon = menuToggle.querySelector('.menu-icon');
        const closeIcon = menuToggle.querySelector('.close-icon');
        if (menuIcon) menuIcon.classList.remove('hidden');
        if (closeIcon) closeIcon.classList.add('hidden');
        // Restore color based on header state
        if (isTransparent && !scrolled) {
          menuToggle.classList.remove('text-deep-charcoal');
          menuToggle.classList.add('text-white');
        }
      }

      // Restore logo color based on header state
      if (header) {
        const logoLink = header.querySelector('.logo-link');
        if (logoLink) {
          if (isTransparent && !scrolled) {
            logoLink.classList.remove('text-deep-charcoal');
            logoLink.classList.add('text-white');
          }
        }
      }
    }
  }

  // Show stock limit notification
  function showStockNotification(message) {
    const existing = document.querySelector('.stock-notification');
    if (existing) existing.remove();

    const notification = document.createElement('div');

    // Check if cart drawer is open
    const cartDrawer = document.getElementById('cart-drawer');
    const isDrawerOpen = cartDrawer && !cartDrawer.classList.contains('translate-x-full');

    if (isDrawerOpen) {
      // Position within cart drawer
      notification.className = 'stock-notification absolute top-20 left-1/2 -translate-x-1/2 bg-amber-500 text-white px-4 py-2 rounded-full text-xs font-medium shadow-lg z-[80] flex items-center gap-2 whitespace-nowrap';
      cartDrawer.appendChild(notification);
    } else {
      // Position on page (for cart page)
      notification.className = 'stock-notification fixed top-24 left-1/2 -translate-x-1/2 bg-amber-500 text-white px-4 py-2 md:px-6 md:py-3 rounded-full text-xs md:text-sm font-medium shadow-lg z-[70] flex items-center gap-2 max-w-[95vw]';
      document.body.appendChild(notification);
    }

    // Use DOM methods instead of innerHTML to prevent XSS
    const icon = document.createElement('span');
    icon.className = 'material-icons text-sm';
    icon.textContent = 'inventory';
    const text = document.createElement('span');
    text.textContent = message;
    notification.appendChild(icon);
    notification.appendChild(text);

    setTimeout(() => {
      notification.style.opacity = '0';
      notification.style.transition = 'opacity 0.3s';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // Free shipping threshold in cents
  const FREE_SHIPPING_THRESHOLD = 1500;

  // iOS-style inventory review state
  let needsReview = false;
  let pendingAdjustments = [];

  // Clear all inventory alerts and reset review state
  function clearInventoryAlerts() {
    needsReview = false;
    pendingAdjustments = [];

    // Remove all inline alert badges
    document.querySelectorAll('.inventory-alert-badge').forEach(el => el.remove());

    // Reset checkout button to original state (iOS: no color change)
    const checkoutBtn = document.querySelector('[data-action="checkout"]');
    if (checkoutBtn) {
      const textEl = checkoutBtn.querySelector('[data-checkout-text]');
      if (textEl) {
        textEl.textContent = 'Proceed to Checkout';
      }
    }
  }

  // Show inline inventory alert badge next to quantity selector (iOS-style)
  function showInlineAlert(itemContainer, adjustment) {
    if (!itemContainer) return;

    // Remove existing alert for this item
    const existingAlert = itemContainer.querySelector('.inventory-alert-badge');
    if (existingAlert) {
      existingAlert.remove();
    }

    // Find the quantity selector wrapper
    const qtyWrapper = itemContainer.querySelector('.quantity-selector')?.parentElement;
    if (!qtyWrapper) return;

    // Make wrapper flex to show alert inline
    qtyWrapper.classList.add('flex', 'items-center', 'gap-2', 'flex-wrap');

    // Create alert badge
    const alertBadge = document.createElement('span');
    alertBadge.className = 'inventory-alert-badge flex items-center gap-1 text-xs';
    alertBadge.dataset.alertFor = adjustment.key;

    if (adjustment.action === 'remove') {
      alertBadge.classList.add('text-red-600');
      alertBadge.innerHTML = `
        <span class="material-icons text-xs">cancel</span>
        <span>Item unavailable</span>
      `;
    } else {
      alertBadge.classList.add('text-amber-600');
      alertBadge.innerHTML = `
        <span class="material-icons text-xs">warning</span>
        <span>Only ${adjustment.actual} left</span>
      `;
    }

    // Insert after quantity selector
    qtyWrapper.appendChild(alertBadge);

    return alertBadge;
  }

  // Scroll to first inventory alert (call after all alerts are shown)
  function scrollToFirstAlert() {
    const firstAlert = document.querySelector('.inventory-alert-badge');
    if (firstAlert) {
      setTimeout(() => {
        firstAlert.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }

  // Update free shipping display (works for both cart drawer and cart page)
  function updateShippingDisplay(container, totalPrice) {
    if (!container) return;

    const shippingStatus = container.querySelector('[data-shipping-status]');
    const progressContainer = container.querySelector('[data-shipping-progress]');
    const remainingEl = container.querySelector('[data-shipping-remaining]');

    if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
      // Update shipping status to Free
      if (shippingStatus) {
        shippingStatus.innerHTML = '<span class="text-green-600 font-bold uppercase tracking-wide">Free</span>';
      }
      // Hide progress bar
      if (progressContainer) {
        progressContainer.classList.add('hidden');
      }
    } else {
      const remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
      // Update shipping status
      if (shippingStatus) {
        shippingStatus.textContent = 'Calculated at checkout';
      }
      // Show and update progress bar
      if (progressContainer) {
        progressContainer.classList.remove('hidden');
        if (remainingEl) {
          remainingEl.textContent = `Add ${formatMoney(remaining)} more for free shipping!`;
        }
      }
    }
  }

  // Cart AJAX Functions - Targeted DOM updates (no image refresh)
  async function updateCartItem(lineKey, requestedQuantity) {
    // Always clear inventory alerts when user modifies cart (iOS behavior)
    clearInventoryAlerts();

    // Find the cart item container in cart drawer
    const cartDrawer = document.getElementById('cart-drawer');
    const itemContainer = cartDrawer?.querySelector(`[data-line-item="${lineKey}"]`);
    const qtySelector = itemContainer?.querySelector('.quantity-selector');

    // Show loading state
    if (qtySelector) {
      qtySelector.style.opacity = '0.5';
    }

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: requestedQuantity
        })
      });

      const result = await response.json();

      // Handle Shopify 422 error (quantity exceeds stock)
      if (result.status === 422 || result.message) {
        // Fetch fresh cart to get actual quantities
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const lineItem = cart.items.find(item => item.key === lineKey);
        const actualQuantity = lineItem ? lineItem.quantity : 0;

        if (actualQuantity > 0 && itemContainer) {
          const qtyInput = itemContainer.querySelector('input[data-action="update-quantity"]');
          if (qtyInput) {
            qtyInput.value = actualQuantity;
          }
          // Show inline alert next to the item (iOS-style)
          showInlineAlert(itemContainer, {
            key: lineKey,
            actual: actualQuantity,
            action: 'reduce'
          });
          scrollToFirstAlert();
        }

        // Update subtotal
        document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
          el.textContent = formatMoney(cart.total_price);
        });
        updateShippingDisplay(cartDrawer, cart.total_price);
        return;
      }

      if (response.ok) {
        const cart = result;

        // Find the actual quantity returned by Shopify
        const lineItem = cart.items.find(item => item.key === lineKey);
        const actualQuantity = lineItem ? lineItem.quantity : 0;

        // Update cart count badges (global)
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });

        // Update subtotal (global)
        document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
          el.textContent = formatMoney(cart.total_price);
        });

        // If item was removed (quantity = 0), refresh the drawer to remove DOM element
        if (actualQuantity === 0) {
          if (cart.item_count === 0) {
            // Cart is empty, refresh to show empty state
            await refreshCartDrawer();
          } else {
            // Just remove this item's DOM element
            if (itemContainer) {
              itemContainer.remove();
            }
            // Update shipping display
            updateShippingDisplay(cartDrawer, cart.total_price);
          }
        } else {
          // Targeted updates - no innerHTML replacement
          if (itemContainer) {
            // Update quantity input
            const qtyInput = itemContainer.querySelector('input[data-action="update-quantity"]');
            if (qtyInput) {
              qtyInput.value = actualQuantity;
            }

            // Update line price (use simple selector since there's only one price per item)
            const priceEl = itemContainer.querySelector('[data-line-price]');
            if (priceEl && lineItem) {
              priceEl.textContent = formatMoney(lineItem.final_line_price);
            }

            // Update data attributes for inventory on + button
            const increaseBtn = itemContainer.querySelector('[data-action="increase-quantity"]');
            if (increaseBtn) {
              increaseBtn.dataset.quantity = actualQuantity + 1;
            }
            const decreaseBtn = itemContainer.querySelector('[data-action="decrease-quantity"]');
            if (decreaseBtn) {
              decreaseBtn.dataset.quantity = Math.max(0, actualQuantity - 1);
            }

            // Show inline alert if quantity was limited by stock (iOS-style)
            if (actualQuantity < requestedQuantity && actualQuantity > 0) {
              showInlineAlert(itemContainer, {
                key: lineKey,
                actual: actualQuantity,
                action: 'reduce'
              });
              scrollToFirstAlert();
            }
          }

          // Update shipping display
          updateShippingDisplay(cartDrawer, cart.total_price);
        }

        // Dispatch cart updated event
        window.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart }
        }));

        // If on cart page and drawer is NOT open, reload to show updated content
        if (window.location.pathname === '/cart' && cartDrawer?.classList.contains('translate-x-full')) {
          location.reload();
        }
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    } finally {
      // Remove loading state
      if (qtySelector) {
        qtySelector.style.opacity = '1';
      }
    }
  }

  async function removeCartItem(lineKey) {
    await updateCartItem(lineKey, 0);
  }

  // updateCartUI is now only used for add-to-cart operations (needs full refresh to show new items)
  async function updateCartUI(cart) {
    // Update cart count badges
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });

    // Update subtotal
    document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
      el.textContent = formatMoney(cart.total_price);
    });

    // Dispatch cart updated event
    window.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: cart
      }
    }));

    // Note: refreshCartDrawer is called separately in addToCart for new items
    // Quantity updates use targeted DOM updates in updateCartItem
  }

  async function refreshCartDrawer() {
    try {
      // Fetch the cart page with section rendering (cache-busting for fresh data)
      const response = await fetch(`/?sections=cart-drawer&_=${Date.now()}`);
      if (response.ok) {
        const data = await response.json();
        if (data['cart-drawer']) {
          // Create a temporary container to parse the HTML
          const temp = document.createElement('div');
          temp.innerHTML = data['cart-drawer'];

          // Update the cart items container
          const newItemsContainer = temp.querySelector('#cart-items-container');
          const currentItemsContainer = document.querySelector('#cart-items-container');
          if (newItemsContainer && currentItemsContainer) {
            currentItemsContainer.innerHTML = newItemsContainer.innerHTML;
          }

          // Update the cart footer (show/hide based on items)
          const cartDrawer = document.getElementById('cart-drawer');
          const newFooter = temp.querySelector('#cart-drawer .p-6.border-t, #cart-drawer .p-8.border-t');
          const currentFooter = cartDrawer?.querySelector('.p-6.border-t, .p-8.border-t, .border-t.border-gray-100');

          // Get the footer container from the new content
          const newDrawerContent = temp.querySelector('#cart-drawer');
          if (newDrawerContent && cartDrawer) {
            // Check if there's a footer in the new content
            const hasNewFooter = newDrawerContent.querySelector('.border-t.border-gray-100.dark\\:border-zinc-800.bg-gray-50');
            const hasCurrentFooter = cartDrawer.querySelector('.border-t.border-gray-100.dark\\:border-zinc-800.bg-gray-50');

            if (hasNewFooter && !hasCurrentFooter) {
              // Add footer
              cartDrawer.appendChild(hasNewFooter.cloneNode(true));
            } else if (!hasNewFooter && hasCurrentFooter) {
              // Remove footer
              hasCurrentFooter.remove();
            } else if (hasNewFooter && hasCurrentFooter) {
              // Update footer
              hasCurrentFooter.innerHTML = hasNewFooter.innerHTML;
            }
          }
        }
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      // Fallback: reload the page
      location.reload();
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Add to Cart with AJAX
  async function addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (response.ok) {
        // Fetch updated cart
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        updateCartUI(cart);
        // Open cart drawer first, then refresh content (better UX - shows immediately)
        openCartDrawer();
        refreshCartDrawer();
        return { success: true };
      } else {
        // Handle stock errors (422 status = inventory limit reached)
        const errorData = await response.json();
        let errorMessage = errorData.description || errorData.message || 'Could not add to cart';

        // Make error message more user-friendly
        if (response.status === 422) {
          // Dispatch event for product page to refresh its inventory data
          window.dispatchEvent(new CustomEvent('inventory:changed', {
            detail: { variantId: variantId }
          }));

          // Check if it's an "all in cart" type message
          if (errorMessage.toLowerCase().includes('all') && errorMessage.toLowerCase().includes('cart')) {
            errorMessage = 'All available stock is already in your cart';
          }

          // For 422 errors, still open cart drawer to show current cart contents
          // Then show the notification on top
          openCartDrawer();
          refreshCartDrawer();
        }

        showStockNotification(errorMessage);
        return { success: false, error: errorMessage, status: response.status };
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      showStockNotification('Error adding to cart. Please try again.');
      return { success: false, error: error.message };
    }
  }

  // Pre-checkout inventory validation (iOS-style: auto-adjust quantities)
  // Strategy: Read UI input values and compare with what Shopify allows
  async function validateAndCheckout(button) {
    const textEl = button.querySelector('[data-checkout-text]');

    // If user already reviewed adjustments, proceed to checkout
    if (needsReview) {
      clearInventoryAlerts();
      window.location.href = '/checkout';
      return;
    }

    // Show loading state
    if (textEl) textEl.textContent = 'Creating Checkout...';
    button.disabled = true;
    button.style.opacity = '0.7';

    try {
      // Collect UI quantities from cart drawer inputs
      const cartDrawer = document.getElementById('cart-drawer');
      const uiQuantities = {};

      if (cartDrawer) {
        cartDrawer.querySelectorAll('[data-line-item]').forEach(itemEl => {
          const lineKey = itemEl.dataset.lineItem;
          const qtyInput = itemEl.querySelector('input[data-action="update-quantity"]');
          if (lineKey && qtyInput) {
            uiQuantities[lineKey] = parseInt(qtyInput.value, 10) || 0;
          }
        });
      }

      // Fetch current server cart
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (cart.item_count === 0) {
        showStockNotification('Your cart is empty');
        return;
      }

      // Validate each item using DOM inventory data (more reliable than API)
      const adjustments = [];

      for (const item of cart.items) {
        // Get the quantity user intended (from UI) or server value
        const requestedQty = uiQuantities[item.key] !== undefined ? uiQuantities[item.key] : item.quantity;

        // Skip if user entered 0 or negative
        if (requestedQty <= 0) continue;

        // Get inventory data from DOM (set by Liquid template)
        const itemEl = cartDrawer?.querySelector(`[data-line-item="${item.key}"]`);
        const increaseBtn = itemEl?.querySelector('[data-action="increase-quantity"]');

        if (increaseBtn) {
          const inventoryQty = parseInt(increaseBtn.dataset.inventoryQuantity, 10);
          const inventoryPolicy = increaseBtn.dataset.inventoryPolicy;
          const inventoryManagement = increaseBtn.dataset.inventoryManagement;

          // Check if inventory is tracked and policy denies overselling
          const isTracked = inventoryManagement === 'shopify';
          const denyOversell = inventoryPolicy !== 'continue';

          if (isTracked && denyOversell && !isNaN(inventoryQty)) {
            if (requestedQty > inventoryQty) {
              // Quantity exceeds available stock
              const actualQty = Math.max(0, inventoryQty);

              adjustments.push({
                key: item.key,
                title: item.product_title,
                variant: item.variant_title,
                requested: requestedQty,
                actual: actualQty,
                action: actualQty === 0 ? 'remove' : 'reduce'
              });

              // Update cart to the available quantity
              if (actualQty !== requestedQty) {
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.key, quantity: actualQty })
                });
              }
              continue;
            }
          }
        }

        // Fallback: Try API validation for items without DOM inventory data
        const changeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: requestedQty })
        });

        const result = await changeResponse.json();

        // Check if Shopify returned a 422 error (quantity exceeded)
        if (result.status === 422) {
          // Fetch fresh cart to get actual quantity
          const freshCartResponse = await fetch('/cart.js');
          const freshCart = await freshCartResponse.json();
          const freshItem = freshCart.items.find(i => i.key === item.key);
          const actualQty = freshItem ? freshItem.quantity : 0;

          adjustments.push({
            key: item.key,
            title: item.product_title,
            variant: item.variant_title,
            requested: requestedQty,
            actual: actualQty,
            action: actualQty === 0 ? 'remove' : 'reduce'
          });
        } else if (result.items) {
          // Normal response - check if quantity was reduced
          const updatedItem = result.items.find(i => i.key === item.key);
          const actualQty = updatedItem ? updatedItem.quantity : 0;

          if (actualQty < requestedQty) {
            adjustments.push({
              key: item.key,
              title: item.product_title,
              variant: item.variant_title,
              requested: requestedQty,
              actual: actualQty,
              action: actualQty === 0 ? 'remove' : 'reduce'
            });
          }
        }
      }

      // If any adjustments were made, notify user and enter review mode
      if (adjustments.length > 0) {
        // Store adjustments and enter review mode
        pendingAdjustments = adjustments;
        needsReview = true;

        // iOS UI always shows same toast message
        showStockNotification('Items adjusted for availability.');

        // Refresh cart drawer to show updated quantities
        await refreshCartDrawer();

        // Show inline alerts on each affected item
        const cartDrawerEl = document.getElementById('cart-drawer');
        if (cartDrawerEl) {
          adjustments.forEach(adj => {
            const itemContainer = cartDrawerEl.querySelector(`[data-line-item="${adj.key}"]`);
            showInlineAlert(itemContainer, adj);
          });
          // Scroll to first alert after all are shown
          scrollToFirstAlert();
        }

        // Re-query the checkout button after refresh (refreshCartDrawer may have replaced it)
        const refreshedBtn = document.querySelector('[data-action="checkout"]');
        const refreshedTextEl = refreshedBtn?.querySelector('[data-checkout-text]');

        // Change button to "Review & Checkout" state (iOS: no color change)
        if (refreshedTextEl) {
          refreshedTextEl.textContent = 'Review & Checkout';
        }
        if (refreshedBtn) {
          refreshedBtn.disabled = false;
          refreshedBtn.style.opacity = '1';
        }

        // Fetch updated cart to check if still has items
        const updatedResponse = await fetch('/cart.js');
        const updatedCart = await updatedResponse.json();

        // Update "Your Bag (X)" header count
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = updatedCart.item_count;
        });

        // Update subtotal
        document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
          el.textContent = formatMoney(updatedCart.total_price);
        });

        if (updatedCart.item_count === 0) {
          showStockNotification('All items were removed due to availability');
          clearInventoryAlerts();
          return;
        }

        // Don't auto-proceed - let user review and click again
        return;
      }

      // All items available - proceed to checkout
      window.location.href = '/checkout';

    } catch (error) {
      console.error('Error validating checkout:', error);
      // On error, proceed to checkout and let Shopify handle validation
      window.location.href = '/checkout';
    } finally {
      // Reset button state only if not in review mode
      if (!needsReview) {
        if (textEl) textEl.textContent = 'Proceed to Checkout';
        button.disabled = false;
        button.style.opacity = '1';
      }
    }
  }

  // Event Delegation
  document.addEventListener('click', function (e) {
    const target = e.target.closest('[data-action]');
    if (!target) return;

    const action = target.dataset.action;

    switch (action) {
      case 'open-cart':
        e.preventDefault();
        openCartDrawer();
        break;

      case 'close-cart':
        e.preventDefault();
        closeCartDrawer();
        break;

      case 'open-mobile-menu':
        e.preventDefault();
        openMobileMenu();
        break;

      case 'close-mobile-menu':
        e.preventDefault();
        closeMobileMenu();
        break;

      case 'toggle-mobile-menu':
        e.preventDefault();
        if (mobileMenuOverlay && !mobileMenuOverlay.classList.contains('hidden')) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
        break;

      case 'remove-item':
        e.preventDefault();
        const removeKey = target.dataset.lineKey;
        removeCartItem(removeKey);
        break;

      case 'decrease-quantity':
        e.preventDefault();
        {
          const lineKey = target.dataset.lineKey;
          const qtyInput = target.closest('.quantity-selector')?.querySelector('input[data-action="update-quantity"]');
          let currentQty = qtyInput ? parseInt(qtyInput.value, 10) : parseInt(target.dataset.quantity, 10);
          let newQty = Math.max(0, currentQty - 1);
          if (qtyInput) qtyInput.value = newQty;
          updateCartItem(lineKey, newQty);
        }
        break;

      case 'increase-quantity':
        e.preventDefault();
        {
          const lineKey = target.dataset.lineKey;
          const qtyInput = target.closest('.quantity-selector')?.querySelector('input[data-action="update-quantity"]');
          let currentQty = qtyInput ? parseInt(qtyInput.value, 10) : parseInt(target.dataset.quantity, 10);
          let newQty = currentQty + 1;

          if (qtyInput) qtyInput.value = newQty;
          updateCartItem(lineKey, newQty);
        }
        break;

      case 'checkout':
        e.preventDefault();
        validateAndCheckout(target);
        break;
    }
  });

  // Handle variant option changes in product cards (Quick Add Modal)
  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('variant-option-input')) {
      handleVariantChange(e.target);
    }
  });

  function handleVariantChange(input) {
    const modal = input.closest('[data-variants]');
    if (!modal) return;

    const form = input.closest('form');
    if (!form) return;

    // Parse variants from data attribute (only once per modal)
    let variants;
    try {
      const variantsData = modal.dataset.variants;
      variants = JSON.parse(variantsData.replace(/&quot;/g, '"'));
    } catch (err) {
      console.error('Error parsing variants:', err);
      return;
    }

    const currency = modal.dataset.currency || 'USD';
    const productId = modal.dataset.productId;

    // Collect selected options
    const options = [];
    form.querySelectorAll('.variant-option-input:checked').forEach(checkedInput => {
      options[parseInt(checkedInput.dataset.optionIndex, 10)] = checkedInput.value;
    });

    // Find matching variant
    const matchedVariant = variants.find(variant => {
      const vOpts = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return options.every((option, index) => vOpts[index] === option);
    });

    const addBtn = form.querySelector('button[type="submit"]');
    const variantInput = form.querySelector('input[name="id"]');
    const priceDisplay = document.getElementById('price-' + productId);

    if (matchedVariant) {
      // Update Price
      if (priceDisplay) {
        priceDisplay.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency
        }).format(matchedVariant.price / 100);
      }

      // Update inventory data attributes
      form.dataset.inventoryQuantity = matchedVariant.inventory_quantity || 999;
      form.dataset.inventoryPolicy = matchedVariant.inventory_policy || '';
      form.dataset.inventoryManagement = matchedVariant.inventory_management || '';
      form.dataset.variantId = matchedVariant.id;

      if (matchedVariant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        addBtn.classList.remove('opacity-50', 'cursor-not-allowed');
        variantInput.value = matchedVariant.id;
        variantInput.setAttribute('value', matchedVariant.id);
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
        addBtn.classList.add('opacity-50', 'cursor-not-allowed');
      }
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      addBtn.classList.add('opacity-50', 'cursor-not-allowed');
    }
  }

  // Handle quantity input changes in cart drawer
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (target.dataset.action === 'update-quantity') {
      const lineKey = target.dataset.lineKey;
      let quantity = parseInt(target.value, 10) || 0;
      quantity = Math.max(0, quantity);

      updateCartItem(lineKey, quantity);
    }
  });

  // Handle Add to Cart forms
  document.addEventListener('submit', async function (e) {
    if (e.target.classList.contains('add-to-cart-form')) {
      e.preventDefault();
      const form = e.target;

      const variantId = form.querySelector('[name="id"]').value;
      const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || 1, 10);

      // Show loading state
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;

      const result = await addToCart(variantId, quantity);

      if (result.success) {
        // Close modal if form is inside one
        const modal = form.closest('[role="dialog"]');
        if (modal) {
          modal.classList.add('hidden');
        }
      }

      // Reset button
      button.textContent = originalText;
      button.disabled = false;
    }
  });

  // Keyboard accessibility
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
    }
  });

  // Initialize
  document.addEventListener('DOMContentLoaded', function () {
    console.log('Natureland theme initialized');
  });

})();
